 
import {SVGProps} from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={96}
    fill="none"
    {...props}
  >
    <path
      fill="#EAEEF9"
      d="M70.844 95.333c25.907 0 46.909-21.073 46.909-47.069 0-25.995-21.002-47.068-46.909-47.068S23.935 22.269 23.935 48.264c0 25.996 21.002 47.07 46.91 47.07ZM43.735 5.235a2.37 2.37 0 0 0 1.514-2.983 2.358 2.358 0 0 0-2.973-1.52 2.37 2.37 0 0 0-1.515 2.983 2.358 2.358 0 0 0 2.974 1.52Z"
    />
    <path fill="#fff" d="M97.083 87H11.854l15.574-71.883h85.323L97.083 87Z" />
    <path
      fill="#D5DAE8"
      d="M97.083 87H11.854l15.574-71.883h85.323L97.083 87Z"
    />
    <path
      fill="url(#a)"
      d="M47.909 87h-17.65c-3.209 0-5.852-2.747-5.663-5.967l2.832-65.916h4.247L47.909 87Z"
    />
    <path
      fill="#fff"
      d="M131.439 87H46.21L31.77 31.785l-.095-.38-4.247-16.289h85.323l3.681 14.112.566 2.178.095.379 14.346 55.213Z"
    />
    <path
      fill="#EFF3FB"
      d="M116.998 31.407H31.675l-4.247-16.29h85.323l3.681 14.112.566 2.178Z"
    />
    <path
      fill="#ADB6C8"
      d="M49.891 26.766a3.025 3.025 0 0 0 3.02-3.03 3.025 3.025 0 0 0-3.02-3.03 3.025 3.025 0 0 0-3.02 3.03 3.025 3.025 0 0 0 3.02 3.03ZM99.726 26.766a3.025 3.025 0 0 0 3.02-3.03 3.025 3.025 0 0 0-3.02-3.03 3.025 3.025 0 0 0-3.02 3.03 3.025 3.025 0 0 0 3.02 3.03Z"
      opacity={0.3}
    />
    <path
      fill="#ADB6C8"
      d="M49.136 24.967a1.05 1.05 0 0 1-1.038-1.042 1.05 1.05 0 0 1 1.038-1.042c2.076 0 4.247-2.936 4.247-7.387v-.379c-.094-4.356-2.265-7.008-4.247-7.008-1.888 0-3.964 2.557-4.247 6.535h-2.171c.283-4.925 3.02-8.618 6.324-8.618 3.492 0 6.229 4.072 6.418 9.28v.285c.094 5.209-2.738 9.376-6.324 9.376ZM98.688 24.967a1.05 1.05 0 0 1-1.039-1.042 1.05 1.05 0 0 1 1.039-1.042c2.076 0 4.247-2.936 4.247-7.387v-.379c-.094-4.356-2.265-7.008-4.247-7.008-1.888 0-3.965 2.557-4.248 6.535h-2.17c.283-4.925 3.02-8.618 6.323-8.618 3.492 0 6.23 4.072 6.418 9.28v.285c.095 5.209-2.737 9.376-6.323 9.376Z"
    />
    <path
      stroke="#D5DAE8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M1 86.904h137.329"
    />
    <path
      fill="#D5DAE8"
      d="M100.198 52.715a.948.948 0 0 1-.944-.947c0-.568.377-.947.944-.947h2.926a.947.947 0 0 1 0 1.894h-2.926Z"
      opacity={0.3}
    />
    <path
      fill="#D5DAE8"
      d="M59.99 79.423c-.378 0-.755-.285-.944-.663l-1.51-5.588H50.08a.947.947 0 0 1 0-1.894h6.89l-2.36-8.334h-7.173a.948.948 0 0 1-.944-.947c0-.569.378-.947.944-.947h6.607l-2.36-8.334H44.89a.948.948 0 0 1-.944-.947c0-.569.377-.948.944-.948h6.323l-2.36-8.334H42.34a.947.947 0 0 1-.944-.947c0-.568.378-.947.944-.947h5.946l-.943-3.41c-.095-.473.188-1.041.66-1.136h.283c.378 0 .755.285.944.663l1.133 3.883h7.55c.567 0 .945.379.945.947 0 .569-.378.947-.944.947h-6.985l2.36 8.334H65.18l-3.775-13.637c-.095-.474.189-1.042.66-1.137h.284c.377 0 .755.285.944.663l1.132 3.883h4.059c.566 0 .944.379.944.947a.947.947 0 0 1-.944.947h-3.493l2.36 8.334h8.023c.566 0 .944.474.944.948 0 .568-.378.947-.944.947h-7.457l2.36 8.334h11.987l-5.191-18.563h-2.549a.947.947 0 0 1 0-1.894h1.982l-.944-3.41c-.094-.283 0-.473.095-.757a.968.968 0 0 1 .566-.473h.283c.378 0 .755.284.944.663l1.133 3.883h1.982c.566 0 .944.378.944.947 0 .568-.378.947-.944.947H79.15l2.36 8.334h11.986l-2.36-8.334h-6.134a.948.948 0 0 1 0-1.895h5.285l-.944-3.409c-.094-.473.19-1.042.661-1.136h.283c.378 0 .755.284.944.663l1.133 3.883h11.987l-.944-3.41c-.095-.473.189-1.042.66-1.136h.284c.377 0 .755.284.943.663l1.133 3.883h7.362c.566 0 .944.378.944.947 0 .568-.378.947-.944.947h-7.079l2.36 8.334h7.079c.566 0 .943.473.943.947 0 .568-.377.947-.943.947h-6.513l2.36 8.334h6.795c.567 0 .944.474.944.947 0 .568-.377.947-.944.947h-6.229l2.36 8.334h6.418a.948.948 0 0 1 0 1.894h-5.946l1.415 5.02c.095.473-.188 1.041-.66 1.136h-.284c-.377 0-.755-.284-.943-.663l-1.51-5.493h-11.987l1.415 4.925c.095.284 0 .474-.094.758a.966.966 0 0 1-.566.473h-.283c-.378 0-.755-.284-.944-.663l-1.51-5.398H87.456l1.416 4.925c.094.473-.19 1.041-.661 1.136h-.283c-.378 0-.755-.284-.944-.663l-1.51-5.398H73.487l1.416 4.925c.094.473-.189 1.041-.66 1.136h-.284c-.378 0-.755-.284-.944-.663l-1.51-5.398H59.518l1.416 5.02c.094.284 0 .473-.094.757a.967.967 0 0 1-.567.474h-.283Zm26.9-8.145h25.955l-2.359-8.334H98.499l.85 3.03c.094.284 0 .474-.095.758a.968.968 0 0 1-.566.474h-.284c-.377 0-.755-.285-.943-.663l-.944-3.505H92.93a.947.947 0 0 1-.944-.947c0-.568.378-.947.944-.947h3.02l-2.36-8.334H81.699l2.36 8.334h2.926c.566 0 .944.474.944.947 0 .569-.378.947-.944.947H84.53l2.36 8.24Zm-13.97 0h11.987l-2.36-8.334H70.562l2.36 8.334Zm-13.968 0h11.987l-2.36-8.334h-3.492a.948.948 0 0 1 0-1.894h3.02l-2.36-8.334H53.761l2.36 8.334h3.114a.947.947 0 0 1 0 1.894h-2.548l2.265 8.334ZM98.027 61.05h11.987l-5.191-18.563H92.741l5.286 18.563Z"
      opacity={0.3}
    />
    <path
      fill="#ADB6C8"
      d="M71.04 51.385c-3.923 0-7.217-2.51-8.473-6.116-.313-.785.157-1.569.942-1.882.784-.314 1.569.156 1.882.94.785 2.353 3.138 4.078 5.648 4.078s4.863-1.568 5.648-4.077c.314-.785 1.098-1.255 1.882-.941.785.313 1.255 1.097.942 1.882-1.255 3.764-4.55 6.116-8.472 6.116ZM94.728 51.385c-3.922 0-7.216-2.51-8.471-6.116-.314-.785.156-1.569.941-1.882.784-.314 1.569.156 1.883.94.784 2.353 3.137 4.078 5.647 4.078 2.51 0 4.864-1.568 5.648-4.077.314-.785 1.098-1.255 1.883-.941.784.313 1.255 1.097.941 1.882-1.255 3.764-4.55 6.116-8.472 6.116ZM87.53 70.588a3.608 3.608 0 1 0 0-7.216 3.608 3.608 0 0 0 0 7.216ZM12.489 5.522V.872h17.97v4.65L18.197 20.317H30.67v4.65H11.854v-4.65L24.116 5.522H12.49ZM35.688 34.867v-2.959h11.628v2.96l-7.822 9.51h8.034v2.959H35.266v-2.96l7.822-9.51h-7.4Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={24.579}
        x2={47.944}
        y1={51.047}
        y2={51.047}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D5DAE8" />
        <stop offset={1} stopColor="#9AA3BA" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
